<template>
  <div
    class="imageGallerySlider-back-div"
    @click="closeGallerySlider($event)"
    id="imageGallerySlider-back-div"
  >
    <div class="imageGallerySlider-box">
      <swiper
        :pagination="{
          dynamicBullets: true,
        }"
        :autoplay="{
          delay: 2500,
          disableOnInteraction: false,
        }"
        :navigation="true"
        :modules="modules"
        class="GallerySlider"
        id="container"
      >
        <swiper-slide>
          <img :src="galleryItem?.file" alt="" />
        </swiper-slide>
        <!-- <template v-for="(item, index) in galleryItem" :key="index">
          <swiper-slide>
            <img :src="item?.file" alt="" />
          </swiper-slide>
        </template> -->

        <!-- <swiper-slide>
          <img src="@/assets/img/sampel-img/s2.jpg" alt="" />
        </swiper-slide>
        <swiper-slide>
          <img src="@/assets/img/sampel-img/s3.jpg" alt="" />
        </swiper-slide>
        <swiper-slide>
          <img src="@/assets/img/sampel-img/s4.jpg" alt="" />
        </swiper-slide>
        <swiper-slide>
          <img src="@/assets/img/sampel-img/s5.jpg" alt="" />
        </swiper-slide> -->
      </swiper>
      <div class="gallery-info">
        <h2>
          {{ galleryItem?.title }}
          <likeButton :likeNumber="galleryItem?.like"></likeButton>
        </h2>

        <div class="description-box">
          <p>{{ galleryItem?.description }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import likeButton from "@/components/likeButton/index.vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay, Pagination, Navigation } from "swiper";
export default {
  name: "galleryImageSlider",
  props: {
    galleryItem: Object,
  },
  components: {
    likeButton,
    Swiper,
    SwiperSlide,
  },
  methods: {
    closeGallerySlider(e) {
      if (e.target.id === "imageGallerySlider-back-div") {
        this.$emit("selectedImage", null);
      }
    },
  },
  setup() {
    return {
      modules: [Autoplay, Pagination, Navigation],
    };
  },
};
</script>

<style lang="css" scoped>
@import url(@/assets/style/components/galleryImageSlider/galleryImageSlider.css);
</style>